import { useEffect, useState } from 'react'

import { setStorageSerializedItem } from '../../../../../utils/storage'
import {
  getBirdviewStorageItemSetKey,
  getBirdviewStorageKey,
  readBirdviewStorageItem,
} from '../../../DashboardBirdview.utils.storage'
import {
  checkIsBirdviewLayoutShape,
  getBirdviewLayoutWidgetIds,
  reconcileBirdviewLayout,
} from '../../BirdviewLayout.utils'
import { useBirdviewLayoutDrag } from '../useBirdviewLayoutDrag'

export function useBirdviewLayout({ defaultLayout, storageKeyPrefix }) {
  const widgetIds = getBirdviewLayoutWidgetIds(defaultLayout)
  const storageKey = getBirdviewStorageKey(storageKeyPrefix, [
    getBirdviewStorageItemSetKey(widgetIds),
  ])

  const [layout, setLayout] = useState(() =>
    reconcileBirdviewLayout({
      defaultLayout,
      layout: readBirdviewStorageItem(storageKey, checkIsBirdviewLayoutShape),
      widgetIds,
    })
  )

  const dragHandlers = useBirdviewLayoutDrag({ layout, setLayout })

  useEffect(() => {
    setStorageSerializedItem(storageKey, layout)
  }, [layout, storageKey])

  return { ...dragHandlers, layout }
}
